interface StepNavProps {
  primaryLabel?: string;
  primaryDisabled?: boolean;
  onPrimary?: () => void;
  primaryType?: 'button' | 'submit';
  primaryArrow?: boolean;
}

export function StepNav({
  primaryLabel,
  primaryDisabled,
  onPrimary,
  primaryType = 'button',
  primaryArrow = false,
}: StepNavProps) {
  return (
    <div className="smash-step-nav">
      {primaryLabel && (
        <button
          type={primaryType}
          onClick={primaryType === 'submit' ? undefined : onPrimary}
          disabled={primaryDisabled}
        >
          {primaryLabel}
          {primaryArrow && (
            <svg
              className="smash-step-nav__arrow"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M3 12 L19 12 M13 6 L19 12 L13 18" />
            </svg>
          )}
        </button>
      )}
    </div>
  );
}
